import React from 'react';
import { Link } from 'react-router-dom';
import styles from './NewsEventCard.module.css';

const NewsEventCard = ({ item }) => {
  const {
    _id,
    title,
    type,
    images,
    content,
    description,
    author,
    startDate,
    location,
    createdAt,
    image // Add this for news items that might use 'image' instead of 'images'
  } = item;

  const getImageUrl = () => {
    if (type === 'event') {
      return images && images[0]
        ? `${process.env.REACT_APP_API_URL}/uploads/events/${images[0]}`
        : '/fallback-image.jpg';
    } else if (type === 'news') {
      // Handle different possible image field structures for news
      if (image) {
        return `${process.env.REACT_APP_API_URL}/uploads/news/${image}`;
      } else if (images && images[0]) {
        return `${process.env.REACT_APP_API_URL}/uploads/news/${images[0]}`;
      }
      return '/fallback-image.jpg';
    }
    return '/fallback-image.jpg';
  };

  const truncateText = (text, maxLength) => {
    if (!text) return '';
    return text.length <= maxLength ? text : `${text.substr(0, maxLength)}...`;
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const displayText = type === 'event' ? description : content;
  const displayDate = type === 'event' ? startDate : createdAt;

  return (
    <div className={styles.card}>
      <div className={styles.imageWrapper}>
        <img 
          src={getImageUrl()} 
          alt={title} 
          className={styles.image} 
          onError={(e) => {
            console.log('Image load error:', e);
            e.target.src = '/fallback-image.jpg';
          }}
        />
        <span className={`${styles.tag} ${styles[type]}`}>
          {type.toUpperCase()}
        </span>
      </div>
      <div className={styles.content}>
        <div className={styles.metadata}>
          <span className={styles.date}>{formatDate(displayDate)}</span>
          {type === 'event' && location && (
            <span className={styles.location}>{location}</span>
          )}
          {type === 'news' && author && (
            <span className={styles.author}>By {author}</span>
          )}
        </div>
        <h3 className={styles.title}>{truncateText(title, 60)}</h3>
        <p className={styles.description}>{truncateText(displayText, 150)}</p>
        <Link 
          to={`/${type}s/${_id}`} 
          className={styles.readMore}
        >
          Read More
        </Link>
      </div>
    </div>
  );
};

export default NewsEventCard;